export default [
  {
    path: '/invoices',
    component: () => import('@/views/invoices/InvoicesList.vue'),
    meta: { 
      title: 'Invoices', 
      requiresAuth: true,
      requiresAmazon: true
    },
  },
  {
    path: '/invoices/details/:id',
    component: () => import('@/views/invoices/InvoiceDetails.vue'),
    meta: { 
      title: 'Invoice', 
      requiresAuth: true,
      requiresAmazon: true
    },
  },
  {
    path: '/invoices/:id/make-payment',
    component: () => import('@/views/invoices/MakePayment.vue'),
    meta: { 
      title: 'Make Payment', 
      requiresAuth: true,
      requiresAmazon: true
    },
  }
]